import { gql } from "@apollo/client";
import NewsPage from "..";
import { client } from "../../../lib/apollo";
import { languageQuery } from "../../../lib/queries/language";
import { newsHeadTitleQuery } from "../../../lib/queries/newsHeadTitleQuery";
import { newsItemsQuery } from "../../../lib/queries/newspage";
import { useLanguageContext } from "../../../src/context/LanguageContext";
import { NewsItemsProps } from "../../../types/NewsItemsProps";

const AllNews = ({ newsItems, headTitle, error, loading }: NewsItemsProps) => {
  const { lang } = useLanguageContext();
  return <NewsPage newsItems={newsItems[lang.code]} headTitle={headTitle} error={error} loading={loading} />;
};

export default AllNews;

export async function getStaticProps({ locale }: { locale: string }) {
  const languages = await client.query({
    query: gql`
      ${languageQuery}
    `,
  });

  const newsItems: any = {};
  for (let i = 0; i < languages.data.languages.length; i++) {
    newsItems[languages.data.languages[i].code] = await client.query({
      query: gql`
        ${newsItemsQuery}
      `,
      variables: {
        language: languages.data.languages[i].code,
      },
    });
  }

  const headTitle = await client.query({
    query: gql`
      ${newsHeadTitleQuery}
    `,
    variables: {
      language: "EN",
    },
  });

  return {
    props: {
      newsItems: newsItems,
      headTitle: headTitle.data,
      error: headTitle.error || null,
      loading: headTitle.loading,
    },
  };
}
